"use client";

import React from "react";
import { CircleAlert, ShieldAlert, Wrench } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const crisisPoints = [];
export default function Productintroduction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="260659" id="productintroduction" className="bg-background text-foreground py-16 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="relative w-full max-w-xl mx-auto lg:max-w-none">
            <div className="absolute -inset-4 bg-accent rounded-3xl transform -rotate-3 scale-105 opacity-40 -z-10"></div>
            <div className="rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-500 border border-border bg-card">
              <img ratio={4 / 3} src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/lympha-mat_boesl_hose.jpg" alt="" />
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            
            
            
            
            <p className="text-muted-foreground font-default mb-8 leading-relaxed !text-2xl">Der BEWEI LYMPHAMAT ist eine angenehme Druck- und Pumpmassage für den ganzen Körper, die den Lymphfluß begünstigt und den Abtransport von Stoffwechselabbaustoffen unterstützt.<div><br /></div><div>Durch sanfte, rhythmische Druckwellen wird der Lymphfluß mittels der mechanischen Kompressionsmassage angeregt - ganz ohne Anstrengung, bekleidet und im Liegen! Einfach relaxen und spüren, wie dein Körper neue Leichtigkeit gewinnt. Das Gewebe wird vitalisiert, die Haut geklärt und verhärtete Muskulatur entspannt.</div></p>

            <ul className="space-y-6">
              {crisisPoints.map((point, index) => <li key={index} data-index={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 mt-1">
                    
                  </div>
                  <div>
                    
                    <p className="text-muted-foreground font-default leading-relaxed">
                      {point.description}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}